// Sidebar.jsx
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FaTachometerAlt, FaUserGraduate, FaBookOpen, FaFileAlt, FaCalendarAlt, FaBellSlash, FaBell } from "react-icons/fa";
import { storedData, secret_key } from '../Constants';
import CryptoJS from "crypto-js";
import './Sidebar.css';

const Sidebar = ({ isOpen }) => {
  const userData = storedData
    ? JSON.parse(CryptoJS.AES.decrypt(storedData, secret_key).toString(CryptoJS.enc.Utf8))
    : null;

  const [isStudentsMenuOpen, setStudentsMenuOpen] = useState(false);
  const [isAcademicsMenuOpen, setAcademicsMenuOpen] = useState(false);
  const [isAccountsMenuOpen, setAccountsMenuOpen] = useState(false);
  const [isEventsMenuOpen, setEventsMenuOpen] = useState(false);
  const [isNotifMenuOpen, setNotifMenuOpen] = useState(false);

  return (
    <aside className={`main-sidebar ${isOpen ? 'active' : ''}`}>
      <div className="sidebar">

        {/* User Panel */}
        <div className="user-panel flex items-center p-4 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-xl mb-3 shadow-md">
          <div className="user-image mr-4">
            <img
              src={userData?.logo_base64 || '/default-avatar.png'}
              alt="Logo"
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                objectFit: "cover",
                border: "3px solid rgba(255,255,255,0.4)"
              }}
            />
          </div>
          <div className="user-info text-white">
            <p className="font-semibold text-lg mb-0">{userData?.company_name}</p>
            <p className="opacity-90 text-sm">{userData?.full_name}</p>
          </div>
        </div>

        {/* Menu */}
        <nav className="menu-nav">
          <ul className="menu-list">
            <li className="menu-item">
              <NavLink to="/" className={({ isActive }) => isActive ? 'menu-link active' : 'menu-link'}>
                <FaTachometerAlt className="menu-icon" />
                <span>Dashboard</span>
              </NavLink>
            </li>

            {/* My Students */}
            <li className="menu-item has-submenu">
              <a href="#" className="menu-link" onClick={() => setStudentsMenuOpen(!isStudentsMenuOpen)}>
                <FaUserGraduate className="menu-icon" />
                <span>My Students</span>
                <i className={`fas ${isStudentsMenuOpen ? 'fa-angle-up' : 'fa-angle-down'}`} />
              </a>
              {isStudentsMenuOpen && (
                <ul className="submenu-list">
                  <li><NavLink to="/students" className="submenu-link">Students</NavLink></li>
                  <li><NavLink to="/attendance" className="submenu-link">Attendance</NavLink></li>
                </ul>
              )}
              
              
            </li>

            {/* Academics */}
            <li className="menu-item has-submenu">
              <a href="#" className="menu-link" onClick={() => setAcademicsMenuOpen(!isAcademicsMenuOpen)}>
                <FaBookOpen className="menu-icon" />
                <span>Academics</span>
                <i className={`fas ${isAcademicsMenuOpen ? 'fa-angle-up' : 'fa-angle-down'}`} />
              </a>
              {isAcademicsMenuOpen && (
                <ul className="submenu-list">
                  <li><NavLink to="/report_form_filter" className="submenu-link">Report Form</NavLink></li>
                  <li><NavLink to="/transcript" className="submenu-link">Transcript</NavLink></li>
                  <li><NavLink to="/assignments" className="submenu-link">Assignments</NavLink></li>
                </ul>
              )}
            </li>

            {/* Accounts */}
            <li className="menu-item has-submenu">
              <a href="#" className="menu-link" onClick={() => setAccountsMenuOpen(!isAccountsMenuOpen)}>
                <FaFileAlt className="menu-icon" />
                <span>Accounts</span>
                <i className={`fas ${isAccountsMenuOpen ? 'fa-angle-up' : 'fa-angle-down'}`} />
              </a>
              {isAccountsMenuOpen && (
                <ul className="submenu-list">
                  <li><NavLink to="/fee_statement_filter" className="submenu-link">Fee Statement</NavLink></li>
                </ul>
              )}
            </li>
            {/* Notifications */}
            {/* Notifications */}
            <li className="menu-item has-submenu">
            <a
            href="#"
            className="menu-link"
            onClick={() => setNotifMenuOpen(!isNotifMenuOpen)}
            >
            <FaBell className="menu-icon" />
            <span>Notifications</span>
            <i className={`fas ${isNotifMenuOpen ? 'fa-angle-up' : 'fa-angle-down'}`} />
            </a>

            {isNotifMenuOpen && (
            <ul className="submenu-list">
            <li>
            <NavLink
            to="/notifications"
            className={({ isActive }) =>
            isActive ? "submenu-link active" : "submenu-link"
            }
            >
            All Notifications
            </NavLink>
            </li>
            </ul>
            )}
            </li>

            {/* Events */}
            <li className="menu-item has-submenu">
              <a href="#" className="menu-link" onClick={() => setEventsMenuOpen(!isEventsMenuOpen)}>
                <FaCalendarAlt className="menu-icon" />
                <span>Calendar & Events</span>
                <i className={`fas ${isEventsMenuOpen ? 'fa-angle-up' : 'fa-angle-down'}`} />
              </a>
              {isEventsMenuOpen && (
                <ul className="submenu-list">
                  <li><NavLink to="/events" className="submenu-link">Events</NavLink></li>
                </ul>
              )}
            </li>

          </ul>
        </nav>

      </div>
    </aside>
  );
};

export default Sidebar;
